import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export const Route = createFileRoute("/cuenta/recuperar")({
  head: () => ({ meta: [{ title: "Recuperar contraseña — Truck Company Center" }, { name: "robots", content: "noindex" }] }),
  component: Recuperar,
});

function Recuperar() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/cuenta/reset-password`,
    });
    setLoading(false);
    if (error) { toast.error(error.message); return; }
    setSent(true);
  }

  return (
    <div className="mx-auto max-w-md px-4 py-16 md:px-6">
      <h1 className="font-display text-3xl font-semibold text-foreground">Recuperar contraseña</h1>
      <p className="mt-2 text-sm text-muted-foreground">Te enviaremos un enlace para crear una nueva contraseña.</p>

      {sent ? (
        <div className="mt-6 rounded-xl border border-success/40 bg-success/10 p-6 text-sm text-foreground">
          Si existe una cuenta con ese email, recibirás un enlace en breve. Revisa también la carpeta de spam.
        </div>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-3 rounded-xl border border-hairline bg-surface p-6">
          <div>
            <Label className="text-xs text-muted-foreground">Email</Label>
            <Input className="bg-surface-2 border-hairline" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
            {loading ? "..." : "Enviar enlace"}
          </Button>
        </form>
      )}

      <div className="mt-4 text-center text-xs">
        <Link to="/cuenta/login" className="text-muted-foreground hover:text-foreground">Volver a iniciar sesión</Link>
      </div>
    </div>
  );
}
